import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

const updateBot = (botId, payload, callback) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_BOT' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const userInfo = localStorage.getItem('userInfo');
        const userId = JSON.parse(userInfo)?.id;
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/bot/${botId}`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
              // 'x-api-version': 'v2',
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_BOT_DONE',
              payload: {
                botId: response?.data,
              },
            });
            if (typeof callback === 'function') {
              callback(botId);
            }
          } else {
            dispatch({
              type: 'UPDATING_BOT_FAILED',
              payload: `Failed to update bot`,
            });
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_BOT_FAILED',
            payload: `Failed to update bot`,
          });
        }
        unsubscribe();
      });
    } catch (e) {
      dispatch({
        type: 'UPDATING_BOT_FAILED',
        payload: `Failed to update bot`,
      });
    }
  };
};

export default updateBot;
